import { Component, Input, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

import { Solution } from '../../../models';

@Component({
  selector: 'solution-description',
  templateUrl: './solution-description.component.html',
  styleUrls: ['./solution-description.component.scss']
})
export class SolutionDescriptionComponent {

  @Input()
  english: boolean;

  @ViewChild('description')
  description: ElementRef;

  // *** Content **** //

  benefitTitle: string;

  @Input()
  solution: Solution;

  // ***************************** //

  constructor() { }

  ngOnChanges (changes: SimpleChanges) {
    this.initContent(changes.english.currentValue)
  }

  initContent(b: boolean) {
    if (b) {
      this.benefitTitle = 'Benefits';
    } else {
      this.benefitTitle = 'Bénéfices';
    }
  }

  scrollToDescription() {
    this.description.nativeElement.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

}
